import { Box, Stack } from '@mui/material';
import StatusDocuments from './StatusDocuments';
import { VigoTypography } from 'src/@vigo/vigo-typography';
import { AttachmentDto } from 'src/models/attachment';
import { Dispatch } from 'react';

interface OrphanConsignmentDocumentsProps {
  docsWithoutStatus: AttachmentDto[];
  setDocViewerOpen: Dispatch<boolean>;
}

const OrphanConsignmentDocuments = ({ docsWithoutStatus, setDocViewerOpen }: OrphanConsignmentDocumentsProps) => {
  if (docsWithoutStatus.length < 1) {
    return null;
  }

  return (
    <Stack direction="column" alignItems="flex-end" gap="15px">
      <Stack direction="row" justifyContent="space-between" mt="20px" width="100%">
        <Box sx={{ flex: 1 }}>
          <VigoTypography
            value="Photos Attached To This Consignment"
            sx={{
              color: theme => (theme.palette.mode === 'light' ? '#2B2D42' : '#fff'),
              fontSize: '1.2rem',
              fontWeight: 'bold'
            }}
          />
        </Box>

        <Box sx={{ width: '20%', paddingLeft: '20px' }}>
          <VigoTypography
            value="Docs"
            sx={{
              color: theme => (theme.palette.mode === 'light' ? '#2B2D42' : '#fff'),
              fontSize: '1.2rem',
              fontWeight: 'bold'
            }}
          />
        </Box>
      </Stack>

      <StatusDocuments
        {...{
          status: { id: 'docsWithoutStatus', statusDocuments: docsWithoutStatus } as any,
          setDocumentViewerOpen: () => setDocViewerOpen(true)
        }}
      />
    </Stack>
  );
};

export default OrphanConsignmentDocuments;
